import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import Particle from "../Particle";
// import VerticalNavBar from "../VerticalNavBar";
import CourseDetails from "./CourseDetails";
import API from "../../utils/api";

// const courses = [
//   {
//     name: "Introduction to Machine Learning",
//     certificate: "https://google.com",
//     instructor: "John Doe",
//     image:
//       "https://images.ctfassets.net/aq13lwl6616q/1zD5vKKiY0hUL1MAGB6bn2/137427172c25ab3409c50c040cbdfc98/JTS.png?w=400&h=225&q=50&fm=webp&bg=transparent",
//     duration: "5",
//     courseLink: "https://google.com",
//     difficulty: "Advanced",
//     completeDate: "2024-09-30",
//     description: "A comprehensive introduction to machine learning concepts.",
//     completionPercentage: 100,
//   },
//   {
//     name: "Introduction to Machine Learning",
//     certificate: "",
//     instructor: "John Doe",
//     image:
//       "https://images.ctfassets.net/aq13lwl6616q/1zD5vKKiY0hUL1MAGB6bn2/137427172c25ab3409c50c040cbdfc98/JTS.png?w=400&h=225&q=50&fm=webp&bg=transparent",
//     duration: 5,
//     courseLink: "https://google.com",
//     difficulty: "Intermediate",
//     completeDate: "2024-09-30",
//     description: "A comprehensive introduction to machine learning concepts.",
//     completionPercentage: 10,
//   },
//   {
//     name: "Introduction to Machine Learning",
//     certificate: "https://google.com",
//     instructor: "John Doe",
//     image:
//       "https://images.ctfassets.net/aq13lwl6616q/1zD5vKKiY0hUL1MAGB6bn2/137427172c25ab3409c50c040cbdfc98/JTS.png?w=400&h=225&q=50&fm=webp&bg=transparent",
//     duration: "5",
//     courseLink: "https://google.com",
//     difficulty: "Advanced",
//     completeDate: "2024-09-30",
//     description: "A comprehensive introduction to machine learning concepts.",
//     completionPercentage: 50,
//   },
//   {
//     name: "Advanced Python Programming",
//     certificate: "https://google.com",
//     instructor: "Jane Smith",
//     image:
//       "https://images.ctfassets.net/aq13lwl6616q/1zD5vKKiY0hUL1MAGB6bn2/137427172c25ab3409c50c040cbdfc98/JTS.png?w=400&h=225&q=50&fm=webp&bg=transparent",
//     duration: "8",
//     courseLink: "https://chatgpt.com/c/953a7ca0-c904-4f94-ac55-738fac145fe5",
//     difficulty: "Beginner",
//     completeDate: "2024-10-01",
//     description:
//       "Master Python with advanced features and techniques.Master Python with advanced features and techniques.Master Python with advanced features and techniques.Master Python with advanced featur.",
//     completionPercentage: 7,
//   },
//   // More courses...
// ];
function Courses(props) {
  const [data, setData] = useState([]);

  useEffect(() => {
    // Load initial data on component mount
    API.get("/api/certification")
      .then((res) => res.data)
      .then((response) => {
        setData(response.certifications);
      })
      .catch((error) => {
        console.error("There was an error fetching the initial data!", error);
      });
  }, []);
  return (
    <>
      <Container fluid className="revision-section">
        <Particle />
        <Container>
          <br />
          <h1>📖 My Learning Journey</h1>
          {/* <CourseDetails courses={courses} /> */}
          <CourseDetails courses={data} />
        </Container>
      </Container>
    </>
  );
}

export default Courses;
